// extracted by mini-css-extract-plugin
export var BtnV2 = "product-old-module--BtnV2--0c3a7";
export var BtnV2Black = "product-old-module--BtnV2--black--38962";
export var BtnV2Borderless = "product-old-module--BtnV2--borderless--3266f";
export var BtnV2Cloud = "product-old-module--BtnV2--cloud--54c97";
export var BtnV2Disabled = "product-old-module--BtnV2--disabled--8c317";
export var BtnV2Focusable = "product-old-module--BtnV2--focusable--faf6a";
export var BtnV2Fullwidth = "product-old-module--BtnV2--fullwidth--e3183";
export var BtnV2Gold = "product-old-module--BtnV2--gold--18e3c";
export var BtnV2Grey = "product-old-module--BtnV2--grey--03952";
export var BtnV2Icon = "product-old-module--BtnV2--icon--97344";
export var BtnV2Lg = "product-old-module--BtnV2--lg--7b6f8";
export var BtnV2Midnight = "product-old-module--BtnV2--midnight--d0a22";
export var BtnV2Multiline = "product-old-module--BtnV2--multiline--27497";
export var BtnV2Nofocus = "product-old-module--BtnV2--nofocus--b87ba";
export var BtnV2Secondary = "product-old-module--BtnV2--secondary--8bb29";
export var BtnV2Sm = "product-old-module--BtnV2--sm--8de86";
export var BtnV2Solid = "product-old-module--BtnV2--solid--d3f64";
export var BtnV2Square = "product-old-module--BtnV2--square--f9493";
export var BtnV2Success = "product-old-module--BtnV2--success--93a80";
export var BtnV2Text = "product-old-module--BtnV2--text--8b246";
export var BtnV2Warning = "product-old-module--BtnV2--warning--86dfc";
export var BtnV2White = "product-old-module--BtnV2--white--cc4c1";
export var BtnV2Xl = "product-old-module--BtnV2--xl--51a32";
export var BtnV2Yellow = "product-old-module--BtnV2--yellow--285d7";
export var ColorBlock = "product-old-module--ColorBlock--7a981";
export var ColorBlockColorGrey = "product-old-module--ColorBlock--colorGrey--a0683";
export var ColorBlockGrey = "product-old-module--ColorBlock--grey--c3b8f";
export var ColorBlockMidGrey = "product-old-module--ColorBlock--midGrey--28586";
export var ColorBlockPink = "product-old-module--ColorBlock--pink--b956f";
export var ColorBlockPrimary = "product-old-module--ColorBlock--primary--d940a";
export var ColorBlockPrimaryDark = "product-old-module--ColorBlock--primaryDark--6cd87";
export var ColorBlockPrimaryLight = "product-old-module--ColorBlock--primaryLight--2656f";
export var ColorBlockPrimaryMid = "product-old-module--ColorBlock--primaryMid--3b0d5";
export var ColorBlockPurple = "product-old-module--ColorBlock--purple--aa12b";
export var ColorBlockRed = "product-old-module--ColorBlock--red--e0ca2";
export var ColorBlockSecondary = "product-old-module--ColorBlock--secondary--822e0";
export var ColorBlockSecondaryDark = "product-old-module--ColorBlock--secondaryDark--56160";
export var ColorBlockSecondaryLight = "product-old-module--ColorBlock--secondaryLight--49992";
export var ColorBlockSecondaryMid = "product-old-module--ColorBlock--secondaryMid--ff1b5";
export var ColorBlockText = "product-old-module--ColorBlock--text--31e70";
export var ColorBlockYellow = "product-old-module--ColorBlock--yellow--3b5d0";
export var ColorBlocks = "product-old-module--ColorBlocks--e11b7";
export var DashboardTopoptions = "product-old-module--Dashboard--topoptions--d2624";
export var HideEmbedded = "product-old-module--HideEmbedded--e2250";
export var ShowEmbedded = "product-old-module--ShowEmbedded--918a7";
export var Template__descriptionContent = "product-old-module--Template__description-content--78e8d";
export var __active = "product-old-module--__active--6fd1f";
export var __custom = "product-old-module--__custom--79a77";
export var _pin = "product-old-module--_pin--2fc0b";
export var _pinText = "product-old-module--_pinText--79344";
export var afterSubmission = "product-old-module--afterSubmission--2e7e6";
export var aliceCarousel__dots = "product-old-module--alice-carousel__dots--ac0ee";
export var aliceCarousel__dotsItem = "product-old-module--alice-carousel__dots-item--ebb34";
export var app = "product-old-module--app--d9d23";
export var blockLeft = "product-old-module--blockLeft--e8364";
export var blockRight = "product-old-module--blockRight--55568";
export var bookings = "product-old-module--bookings--463ec";
export var bookingsDesc = "product-old-module--bookingsDesc--8b8dd";
export var btnGroup = "product-old-module--btn-group--13d00";
export var ccCompliance = "product-old-module--cc-compliance--b12e6";
export var cta = "product-old-module--cta--939bf";
export var demo = "product-old-module--demo--3a9a2";
export var demoMobile = "product-old-module--demoMobile--57004";
export var demoPlay = "product-old-module--demoPlay--97e74";
export var demoPopup = "product-old-module--demoPopup--30249";
export var demoPopupOpen = "product-old-module--demoPopupOpen--c675d";
export var donations = "product-old-module--donations--d7a58";
export var embed = "product-old-module--embed--8323f";
export var fadeAcross1 = "product-old-module--fadeAcross1--08a71";
export var fadeAcross2 = "product-old-module--fadeAcross2--9a149";
export var fadeAcross3 = "product-old-module--fadeAcross3--61b89";
export var fadeInDown = "product-old-module--fadeInDown--22c2b";
export var fakeInput = "product-old-module--fakeInput--dbdb5";
export var fakeLabel = "product-old-module--fakeLabel--251ad";
export var flash = "product-old-module--flash--b0481";
export var flex = "product-old-module--flex--738fe";
export var h1 = "product-old-module--h1--b2700";
export var h2 = "product-old-module--h2--13c2a";
export var h3 = "product-old-module--h3--5aa17";
export var h4 = "product-old-module--h4--8509c";
export var hero = "product-old-module--hero--47db5";
export var heroText = "product-old-module--heroText--59051";
export var hideSm = "product-old-module--hideSm--2f0d7";
export var integrationsBlock = "product-old-module--integrationsBlock--db9bc";
export var landingForm = "product-old-module--landingForm--9b61d";
export var landingFormBanner = "product-old-module--landingFormBanner--d8527";
export var landingFormContent = "product-old-module--landingFormContent--5aefa";
export var landingFormImg1 = "product-old-module--landingFormImg1--59501";
export var landingFormImg2 = "product-old-module--landingFormImg2--7ea08";
export var landingFormInner = "product-old-module--landingFormInner--889b3";
export var link = "product-old-module--link--b21ec";
export var logic = "product-old-module--logic--ecf06";
export var logo = "product-old-module--logo--33763";
export var maxWidth = "product-old-module--max-width--78f6f";
export var menuOpen = "product-old-module--menu-open--09715";
export var noChildPMb = "product-old-module--no-child-p-mb--e137d";
export var nobar = "product-old-module--nobar--ef08a";
export var paymentTab = "product-old-module--paymentTab--77d4d";
export var payments = "product-old-module--payments--a80bf";
export var pin = "product-old-module--pin--84292";
export var questionTypes = "product-old-module--questionTypes--9c3e4";
export var questionTypesBanner = "product-old-module--questionTypesBanner--4a690";
export var questionTypesInner = "product-old-module--questionTypesInner--a40d5";
export var seogroup = "product-old-module--seogroup--cc7cc";
export var spin = "product-old-module--spin--5c409";
export var step1 = "product-old-module--step1--66194";
export var submit = "product-old-module--submit--228c2";
export var subscriptions = "product-old-module--subscriptions--f4c86";
export var svgAnim = "product-old-module--svgAnim--51d4f";
export var tab = "product-old-module--tab--daa5d";
export var video = "product-old-module--video--907f0";
export var whatIsPaperform = "product-old-module--whatIsPaperform--1ae7b";
export var whatIsPaperformBanner = "product-old-module--whatIsPaperformBanner--4c660";